import { useEffect, useState } from 'react'
import styled from 'styled-components'
import useViewport from '../../hooks/useViewport'
import { ChartWithZoomable, PredictionChartWrapper } from '../../components'
import { useChartZoomable } from '../../hooks'

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`

const PredictionDashboard = ({
  predictionResult,
  userShifts,
  sleepTime,
  ingestedCaffeine,
  bacLevels,
}) => {
  const [graphSize, setGraphSize] = useState(720)
  const [seeTotalPeriod, setSeeTotalPeriod] = useState(false)
  const { width } = useViewport()
  const { getEightHoursBackAndTwentyHoursFowardData } = useChartZoomable({
    seeTotalPeriod,
  })

  useEffect(() => {
    if (width <= 1160) {
      setGraphSize(width * 0.7)
      return
    }

    if (width > 1160 && width <= 1290) {
      setGraphSize(width * 0.6)
      return
    }

    if (width >= 1290 && width <= 1460) {
      setGraphSize(width * 0.65)
      return
    }

    if (width > 1460) {
      setGraphSize(width * 0.7)
      return
    }
  }, [width])

  return (
    <Container>
      <ChartWithZoomable
        seeTotalPeriod={seeTotalPeriod}
        onChange={() => setSeeTotalPeriod(!seeTotalPeriod)}
      >
        <PredictionChartWrapper
          predictionResult={getEightHoursBackAndTwentyHoursFowardData({
            action: predictionResult,
          })}
          userShifts={getEightHoursBackAndTwentyHoursFowardData({
            action: userShifts,
          })}
          sleepTime={getEightHoursBackAndTwentyHoursFowardData({
            action: sleepTime,
          })}
          graphSize={graphSize}
          ingestedCaffeine={getEightHoursBackAndTwentyHoursFowardData({
            action: ingestedCaffeine,
          })}
          bacLevels={bacLevels}
        />
      </ChartWithZoomable>
    </Container>
  )
}

export default PredictionDashboard
